import BaseFormPresenter from "../../../base/BaseFormPresenter";

class EmployeeFormPresenter extends BaseFormPresenter {
  onChangeObject(object) {
    this.change = object;
    this.object = object;
  }
}

export default EmployeeFormPresenter;
